import React, { Component } from "react";

export default class ZComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			module: null,
			fakeql: null
		};
	}

	componentDidMount() {
		const modelPath = this.props.data[0]._namespace+this.props.data[0]._model;
		import("../components/shared/"+modelPath+(this.props.data.length > 1 ? "All" : "Get"))
			.then(module => {
				this.setState({ module: module.default })
			})
		let nodes = this.props.data.map((node) => node);
		nodes.forEach((node, index) => {
			nodes[index] = {
				node: node
			}
		});
		let fakeql = {};
		fakeql[`all${modelPath}`] = { edges: nodes };
		fakeql["site"] = {
			"siteMetadata": {
				title: `Zehnder Gatsby Starter`,
				description: `Welcome to the Zehnder Gatsby Starter Project.`,
				author: `@TwitterHandle`,
				siteUrl: 'https://www.z-comm.com',
				twitterHandle: '@TwitterHandle',
			}
		}
		this.setState({fakeql: fakeql});
	}

	render() {
		const C = this.state.module;
		return (
			<div>
				{C && <C data={this.state.fakeql} />}
			</div>
		)
	}
}